import React from "react";
import style from "./style.module.scss";
import ChildTableRow from "./ChildTableRow";

function ChildTable({ data = [] }) {
  const getTotalTransactionAmount = () => {
    return data.reduce(
      (total, transaction) => total + transaction.trans_amt,
      0,
    );
  };

  const getTotalNetAmount = () => {
    return data.reduce((total, transaction) => total + transaction.net_amt, 0);
  };

  const getTotalAdjAmount = () => {
    return data.reduce((total, transaction) => total + transaction.adj_amt, 0);
  };

  return (
    <tr className={style.child_row}>
      <td colSpan={11} className={style.child_row_cell}>
        <table className={style.child_table}>
          <thead>
            <tr className={`${style.child_header_row} ${style.line_after}`}>
              <th></th>
              <th>
                <div className={`${style.child_header_cell} ${style.br_left}`} title="Reference no.">
                  Reference no.
                </div>
              </th>
              <th className={style.child_header_cell} title="Type">Type</th>
              <th className={style.child_header_cell} title="Trans. amount">Trans. amount</th>
              <th className={style.child_header_cell} title="Date">Date</th>
              <th className={style.child_header_cell} title="Description">Description</th>
              <th className={style.child_header_cell} title="Represented">Represented</th>             
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              return (
                <ChildTableRow
                  data={row}
                  key={index}
                  lastRow={data?.length == index + 1}
                />
              );
            })}

            {/* total row */}
            {/* <tr className={`${style.total_row}`}>
              <td className={style.child_table_cell} colSpan={2}>
                Transaction count:
              </td>
              <td className={style.child_table_cell}>{data?.length}</td>
              <td className={style.child_table_cell} colSpan={5}></td>
              <td className={style.child_table_cell}>Totals:</td>
              <td className={style.child_table_cell}>
                $ {getTotalTransactionAmount()}.00
              </td>
              <td className={style.child_table_cell}>
                $ {getTotalNetAmount()}.00
              </td>
              <td className={style.child_table_cell}>
                $ {getTotalAdjAmount()}.00
              </td>
            </tr> */}
          </tbody>
        </table>
      </td>
    </tr>
  );
}

export default ChildTable;
